import React, { useState, useEffect, useRef } from 'react';
import { Container, TextField, Select, MenuItem,InputLabel,FormControl,Autocomplete,Button } from '@mui/material';
import moment from 'moment';
import momentTz from 'moment-timezone';
import Swal from 'sweetalert2';
import "./Monitor.css";
import "../../assets/css/custom.css";
import { MdAirlineSeatReclineExtra } from "react-icons/md";
import { FaCarSide } from "react-icons/fa";
import { GiCarDoor } from "react-icons/gi";
import ReactSwitch from 'react-switch';
import { BsFillFuelPumpFill } from "react-icons/bs";
import { IoIosSpeedometer } from "react-icons/io";
import { FaChevronCircleLeft } from "react-icons/fa";
import { FaChevronCircleRight, FaLock, FaUnlock, FaBullhorn, FaLightbulb, FaMapMarkerAlt } from "react-icons/fa";
import GoogleMapComponent from './GoogleMapComponent';
import { baseURL } from '../base_url';
import axios from 'axios';
import { PuffLoader } from 'react-spinners';
import { GiCarWheel } from "react-icons/gi";
import { PiEngineFill } from "react-icons/pi";
import * as turf from '@turf/turf';
import { GrMapLocation } from "react-icons/gr";
import { FaLocationArrow } from "react-icons/fa";
import { FaRegDotCircle } from "react-icons/fa";
import html2canvas from 'html2canvas';
import { RiScreenshot2Fill } from "react-icons/ri";
import { MdOutlineRefresh } from "react-icons/md";



const Monitor = () => {
  const [activeItem, setActiveItem] = useState(null);
  const [checked, setChecked] = useState(true);
  const [isCarNotSelected, SetIsCarNotSelected] = useState(true);
  const [lockStatus, SetLockStatus] = useState('Un Locked')
  const [selectMonitorType, setSelectMonitorType] = useState('all_vehicle');
  const [underLineSelected, setUnderLineSelected] = useState(true);
  const [underLineSelected2, setUnderLineSelected2] = useState(false);
  const [isDetailsOpen, setIsDetailsOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [geofenceCoordinates, setGeofenceCoordinates] = useState([])
  const [fleetMonitorList, setFleetMonitorList] = useState([])
  const [selectedAddress, setSelectedAddress] = useState('')
  const [locationItems, setLocationItems] = useState([])
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedVehicleInfo, setSelectedVehicleInfo] = useState('');
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [currentStatusItems, setCurrentStatusItems] = useState([])
  const [selectedCurrentStatus, setSelectedCurrentStatus] = useState({ label: "All", value: "0" });

  const [hornOn, setHornOn] = useState(false);
  const [lightsOn, setLightsOn] = useState(false);
  const [loadingCommand, setLoadingCommand] = useState(null);
  const [doorLocked, setDoorLocked] = useState(true);
  const [selectedVin, setSelectedVin] = useState(null);
  const [carFinderResult, setCarFinderResult] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [carFinderResults, setCarFinderResults] = useState({});

  const loggedInUser = sessionStorage.getItem("tm_token");
  const foundUser = JSON.parse(loggedInUser);
  const rowRef = useRef(null);
  const handleChange = val => {
    setChecked(val)
    if(val == true){
      SetLockStatus('Un Locked')
    }else{
      SetLockStatus('Locked')
    }
  }

  const handleCarFinderRefresh = async () => {
    try {
      setIsRefreshing(true);

      const loc_id = selectedLocation["id"];
      const status = selectedCurrentStatus["value"];
      const vin = selectedVin;

      const res = await axios.get(
        `${baseURL}/get_fleets_monitor_vin?status=active&loc_id=${loc_id}&admin_id=${foundUser["tm_id"]}&current_status=${status}&vin=${vin}`
      );

      if (res.data.status === '1') {
        setSelectedVehicleInfo(res.data.data);  // Update first

        Swal.fire({
          icon: 'success',
          title: 'Location Updated',
          text: 'The current location of the vehicle has been updated successfully.',
          timer: 2000,
          showConfirmButton: true,
        });
      } else {
        setSelectedVehicleInfo([]);

        Swal.fire({
          icon: 'error',
          title: 'No Data Found',
          text: 'Unable to fetch the current location for the selected vehicle.',
        });
      }
    } catch (error) {
      console.error("Refresh failed:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something went wrong while refreshing.',
      });
    } finally {
      setTimeout(() => {
        setIsRefreshing(false);
      }, 2000);
    }
  };

  const handleCommandClick = async (commandType) => {
    setLoadingCommand(commandType);
  
    const vin = selectedVin;
    let operation = '';
    let params = {};
    if (commandType === 'lock_unlock') {
      operation = 'doorTrunk';
      params = { lock: !doorLocked };
  
    } else if (commandType === 'horn_lights') {
      const newHorn = !hornOn;
      const newLights = !lightsOn;
  
      if (!newHorn && !newLights) {
        return;
      }
  
      operation = 'hornLights';
      params = {};
      if (newHorn) params.horn = true;
      if (newLights) params.lights = true;
  
    } else if (commandType === 'horn') {
      if (!hornOn) {
        operation = 'hornLights';
        params = { horn: true, lights: false };
      } else {
        return;
      }
    }else if (commandType === 'lights') {
      if (!lightsOn) {
        operation = 'hornLights';
        params = { horn: false, lights: true };
      } else {
        return;
      }
    }
    else if (commandType === 'car_finder') {
      operation = 'carFinder';
      params = {};
    }
  
  
    try {
      let payload = {
        id: vin,
        idType: 0,
        operationType: 'REQUEST',
        operation
      };
  
      if (operation === 'doorTrunk') {
        payload.doorTrunk = params;
      } else if (operation === 'hornLights') {
        payload.hornLights = params;
      }
      const reqRes = await fetch(baseURL +'/remote_command_REQ', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
  
      const reqData = await reqRes.json();
      if (!reqRes.ok) {
        const errorCode = reqData?.error?.errorCode || 'UNKNOWN_ERROR';
        const errorMsg = reqData?.error?.errorDescription || reqData?.message || 'Remote command failed.';
  
        Swal.fire({
          icon: 'error',
          title: `Error: ${errorCode}`,
          text: errorMsg,
        });
  
        setLoadingCommand(null);
        return;
      }
      
  
      const correlationId = reqData["data"]["correlationId"];
      
      const resRes = await fetch(baseURL +'/remote_command_RES', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          id: selectedVin,
          idType: 0,
          operationType: 'RESPONSE',
          operation,
          correlationId
        })
      });
  
      const resData = await resRes.json();
  
      if (!resRes.ok || !resData.success) {
        const errorCode = resData?.error?.errorCode || 'UNKNOWN_ERROR';
        const errorMsg = resData?.error?.errorDescription || resData?.message || 'Remote command failed.';
        if(errorCode === "REMOTE_OPERATION_NOT_FOUND")
        {
          Swal.fire({
            icon: 'info',
            title: 'Try Again',
            text: "Unknown Situation",
          });
        }
        else
        {
          Swal.fire({
            icon: 'error',
            title: `Error: ${errorCode}`,
            text: errorMsg,
          });
        }
       
  
        setLoadingCommand(null);
        return;
      }
  
      let successMessage = 'Command executed successfully.';
  
      switch (commandType) {
        case 'lock_unlock':
          const newLockState = !doorLocked;
          setDoorLocked(newLockState);
          successMessage = newLockState ? 'Door locked successfully!' : 'Door unlocked successfully!';
          break;
  
        case 'horn':
          const newHornState = !hornOn;
          setHornOn(newHornState);
          successMessage = newHornState ? 'Horn turned ON!' : 'Horn turned OFF!';
          break;
  
        case 'lights':
          const newLightsState = !lightsOn;
          setLightsOn(newLightsState);
          successMessage = newLightsState ? 'Lights turned ON!' : 'Lights turned OFF!';
          break;
  
          case 'car_finder':
            if (resData?.success) {
              setCarFinderResults(prev => ({ 
                ...prev, 
                [selectedVin]: 'Success' 
              }));
              successMessage = 'Car Finder request sent successfully!';
            } else {
              setCarFinderResults(prev => ({ 
                ...prev, 
                [selectedVin]: 'Failed' 
              }));
              successMessage = 'Car Finder request failed.';
            }
            break;
  
        default:
          break;
      }
  
      Swal.fire({
        icon: 'success',
        title: 'Remote Command Successful',
        text: successMessage,
      });
  
    } catch (error) {
      console.error('Remote command error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Command Failed',
        text: error.message,
      });
    }
    setLoadingCommand(null);
  };
  
  const renderButtonContent = (icon, label, commandType) => {
    return loadingCommand === commandType ? (
      <>
        <span className="spinner-border spinner-border-sm me-2" role="status" />
        Please wait...
      </>
    ) : (
      <>
        {icon} {label}
      </>
    );
  };

  const ConvertToTimeZone = (datetime, loc_id) => {
    const timezone = {
      '6': 'America/Denver',
      '20': 'America/Denver',
      '3': 'America/New_York',
      '5': 'America/New_York',
      '4': 'America/Chicago',
      '2': 'America/Toronto', 
      '1': 'America/Edmonton',
      '7': 'America/Vancouver',
      '9': 'America/Toronto',
      '8': 'America/Toronto',
      '12': 'America/Toronto',
      '21': 'Asia/Dubai'
  }
  const convertedTime = moment(datetime).tz(timezone[loc_id]).format('YYYY-MM-DD HH:mm:ss A');
  return convertedTime
  };

  useEffect(() => {
    setLoading(true);
    axios.get(baseURL + "/get_location_setup?status=active&admin_id=" + foundUser['tm_id']).then((res) => {
      const menuList2 = res.data.data.map((val1) => {
      // return <MenuItem key={val1._id} value={val1._id}>{val1.location_name}</MenuItem>
          return { label: val1.location_name, id: val1._id }
      })
      setLocationItems(menuList2)
      setLoading(false);
    });
    const allStatus = { label: "All", id: "0" };
    let loc_id = selectedLocation && selectedLocation.id ? selectedLocation.id : 0;
    axios.get(baseURL + "/get_current_status?loc_id=" + loc_id).then((res2) => {
      const menuList3 = res2.data.data.map((val1) => {
        return { label: val1, id: val1 }
      })
      setCurrentStatusItems([allStatus, ...menuList3])
    });
  },[]);

  const handleItemClick = (index) => {
    const filteredData = fleetMonitorList.filter(item => item.vin_number === index);
    setSelectedVehicleInfo(filteredData);
    setActiveItem(index);
    setSelectedVin(index);
    SetIsCarNotSelected(false);
    setSelectMonitorType('one_vehicle')
    fetchAddress(filteredData[0].tele_data.geolocation.latitude, filteredData[0].tele_data.geolocation.longitude);
  };
  const carDetailsHandle = (e) => {
    setActiveItem(null);
    SetIsCarNotSelected(true);
    setSelectMonitorType('geofence')
  }
  const fetchTeleData = (loc_id,current_status) => {
    setLoading(true);
    setFleetMonitorList([])
    axios.get(baseURL + "/get_fleets_monitor?status=active&loc_id="+loc_id+"&admin_id=" + foundUser['tm_id']+"&current_status=" + current_status).then((res) => {
      if (res.data.status == '1'){
        setLoading(false);
        setFleetMonitorList(res.data.data)
      }else{
        setLoading(false);
        setFleetMonitorList([])
      }
    });
  }
  const handleLocationChange = (event, newValue) => {
    setSelectedLocation(newValue);
    setGeofenceCoordinates([])
    if(newValue){
      axios.get(baseURL + "/get_geofence_state?loc_id="+newValue.id+"&admin_id=" + foundUser['tm_id']).then((res) => {
        setGeofenceCoordinates(res.data)
      });
      let current_status = selectedCurrentStatus && selectedCurrentStatus.id ? selectedCurrentStatus.id : 0;
      if(geofenceCoordinates)
      {
        fetchTeleData(newValue.id,current_status);
      }
      else{
        setFleetMonitorList([])
      }
      
    }else{
      setFleetMonitorList([])
      setGeofenceCoordinates([])
    }
    return false;
  }

  const handleCurrentStatusChange = (event, newValue) => {
    setSelectedCurrentStatus(newValue);
    fetchTeleData(selectedLocation.id,newValue.id);
    return false;
  }
  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     if (selectedLocation.id) {
  //       fetchTeleData(selectedLocation.id);
  //     }
  //   }, 10000);
    
  //   // Cleanup function to clear the interval when component unmounts or when selectedLocation changes
  //   return () => clearInterval(intervalId);
  // }, [selectedLocation, fleetMonitorList]);

  const fetchAddress = async (latitude, longitude) => {
    try {
      const response = await axios.get(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`);
      setSelectedAddress(response.data.display_name);
    } catch (error) {
      setSelectedAddress("");
    }
  };
  const isInsideGeofence = (position) => {
    if (geofenceCoordinates.parking && geofenceCoordinates.parking.length > 0) {
      // Ensure the polygon is closed by repeating the first coordinate at the end
      const closedGeofenceCoordinates = [...geofenceCoordinates.parking, geofenceCoordinates.parking[0]];
      
      const point = turf.point(position);
      const polygon = turf.polygon([closedGeofenceCoordinates]);
      return turf.booleanPointInPolygon(point, polygon);
    } else {
      return false; // Handle the case where geofenceCoordinates is not properly defined
    }
  };
  const isInsideGeofenceState = (position) => {
    if (geofenceCoordinates.state && geofenceCoordinates.state.length > 0) {
      // Ensure the polygon is closed by repeating the first coordinate at the end
      const closedGeofenceCoordinates = [...geofenceCoordinates.state, geofenceCoordinates.state[0]];
      
      const point = turf.point(position);
      const polygon = turf.polygon([closedGeofenceCoordinates]);
      return turf.booleanPointInPolygon(point, polygon);
    } else {
      return false; // Handle the case where geofenceCoordinates is not properly defined
    }
  };
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const filteredList = fleetMonitorList.filter(val =>
    val.plate.toLowerCase().includes(searchQuery.toLowerCase()) ||
    val.make.toLowerCase().includes(searchQuery.toLowerCase()) ||
    val.model.toLowerCase().includes(searchQuery.toLowerCase()) ||
    val.vin_number.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const handleUnitType = (value, selected_unit) => {
    if(selected_unit == "Miles"){
      return (parseFloat(value) * 0.621371).toFixed(2);
    }else if(selected_unit == "Meter"){
      return (parseFloat(value) * 1000).toFixed(2);
    }else{
      return value
    }
  };
  const handleglType = (value, selected_gl) => {
    if (value === undefined || value === null || isNaN(value) || value === '') {
      return 'N/A';
    }
  
    const numericValue = parseFloat(value);
  
    if (selected_gl === "Gallon") {
      const v = (numericValue * 0.264172).toFixed(2);
      return v + ' Gallon';
    } else {
      return numericValue + ' Liter';
    }
  };

  const handleSelectMonitorType = () => {
    setSelectMonitorType('all_vehicle')
    setUnderLineSelected(true)
    setUnderLineSelected2(false)
  }
  const handleSelectMonitorType2 = () => {
    setSelectMonitorType('geofence')
    setUnderLineSelected(false)
    setUnderLineSelected2(true)
  }
  
  const closeAllCars = () => {
    setIsDetailsOpen(false);
  }
  const openAllCars = () => {
    setIsDetailsOpen(true);
  }
  const dataToSend = { location: 'all', vehicle: selectMonitorType };

  const handleScreenshot = async () => {
    const vinNumber = selectedVehicleInfo[0].vin_number
    const rowElement = rowRef.current;
    html2canvas(rowElement, {
        useCORS: true,
        scrollX: 0,
        scrollY: 0,
        windowWidth: document.documentElement.scrollWidth,
        windowHeight: document.documentElement.scrollHeight,
        x: rowElement.scrollLeft,
        y: rowElement.scrollTop,
        width: rowElement.scrollWidth,
        height: rowElement.scrollHeight,
        scale: window.devicePixelRatio // To handle high DPI screens
    }).then(rowCanvas => {
        const url = rowCanvas.toDataURL();
        const link = document.createElement('a');
        link.href = url;
        link.download = `${vinNumber}.png`; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    });
  };
  return(
      <div className='body_class'>
        {loading ? (
            <div className="loader-overlay">
                <div className="loader">
                <PuffLoader color="#00308F" loading={true} size={200} />
                </div>
            </div>
        ) : ("")}
          <Container>
              <>
              <div style={{ display: "flex", justifyContent: "right", padding:"7px"}}>
                <Button size='small' variant="contained" onClick={handleScreenshot}>
                  <RiScreenshot2Fill size={25}/>&nbsp;Take Screenshot
                </Button>
              </div>
              <div className='p-1 madatory_fields custom_monitor_screen' ref={rowRef}>
                <div className='row' style={{minHeight:"87vh"}}>
                  {isDetailsOpen ?
                  <>
                  {isCarNotSelected?(
                  <div className='col-3 margin' style={{borderRight:"1px solid #ccc"}}>
                      <Autocomplete
                        size='small'
                        disablePortal
                        className='mt-2'
                        id="combo-box-demo"
                        options={locationItems}
                        value={selectedLocation}
                        onChange={handleLocationChange}
                        isOptionEqualToValue={(option, selectedLocation) => option.id === selectedLocation.id}
                        renderInput={(params) => <TextField {...params} label="Location" />}
                      />
                      <Autocomplete
                        size='small'
                        disablePortal
                        className='mt-2'
                        id="combo-box-demo"
                        options={currentStatusItems}
                        value={selectedCurrentStatus}
                        onChange={handleCurrentStatusChange}
                        isOptionEqualToValue={(option, selectedCurrentStatus) => option.id === selectedCurrentStatus.id}
                        renderInput={(params) => <TextField {...params} label="Current Status" />}
                        style={{paddingTop:"8px"}}
                      />
                    <TextField
                      size='small'
                      fullWidth
                      type="text"
                      label="Search"
                      placeholder='Plate / Make / Model / VIN'
                      className='mt-3'
                      value={searchQuery} 
                      onChange={handleSearchChange} 
                    />
                  <div className='row text-center p-2'>
                    <div className='col-6'><b onClick={handleSelectMonitorType} style={{cursor:"pointer",textDecoration: underLineSelected ? "underline" : ""}}>ALL VEHICLES</b></div>
                    <div className='col-6'><b onClick={handleSelectMonitorType2} style={{cursor:"pointer",textDecoration: underLineSelected2 ? "underline" : ""}}>GEOFENCES</b></div>
                    <div className=''><FaChevronCircleLeft  onClick={closeAllCars} className='circleLeft'/></div>
                  </div>
                  <ul className="list-group" style={{maxHeight:"500px",overflowY:"scroll"}}>
                    {filteredList.map((val, i) => (
                    <>
                    <li className={`list-group-item pt-2 ${0 === activeItem ? 'active_car' : ''}`} style={{cursor:"pointer"}} onClick={() => handleItemClick(val.vin_number)}>
                      <div className='row d-flex align-items-center'>
                        <div className='col-12'>
                          <text><b>{val.vin_number}</b></text>
                        </div>
                        <div className='col-12'>
                          <text><b>{val.plate}</b> - {val.make} {val.model}</text>
                        </div>
                        <div className='col-7'>
                          <text style={{color:val.agreement_type === 'In Agreement'?'green':'grey'}}>{val.agreement_type}</text>
                        </div>
                        <div className='col-5'>
                          {/* <text style={{color:(val.tele_data.status && val.tele_data.status.value === 'driving')?'green':'orange'}}><b><FaRegDotCircle /> {(val.tele_data.status)?val.tele_data.status.value:"N/A"}</b></text> */}
                          <text style={{ color: (typeof val.tele_data?.status === "object" 
                              ? val.tele_data.status?.value 
                              : val.tele_data?.status) === 'driving' ? 'green' : 'orange' }}>
                            <b>
                              <FaRegDotCircle /> {typeof val.tele_data?.status === "object" 
                                ? val.tele_data.status?.value 
                                : val.tele_data?.status || "N/A"}
                            </b>
                          </text>
                        </div>
                        <div className='col-1'>
                          <span style={{backgroundColor:(!isInsideGeofenceState([val.tele_data.geolocation.latitude, val.tele_data.geolocation.longitude]))?"red":((val.current_status==="In Maintenance")?"grey":(val.agreement_type === 'Off Agreement' && isInsideGeofence([val.tele_data.geolocation.latitude, val.tele_data.geolocation.longitude]))?"black":((val.agreement_type === 'Off Agreement' && !isInsideGeofence([val.tele_data.geolocation.latitude, val.tele_data.geolocation.longitude]))?"red":"green"))}} className='vehicle_status_indicator'>1</span>
                        </div>
                      </div>
                    </li>
                    </>
                    ))}
                  </ul>
                  </div>
                  ):(
                    <>
                    <div className=''><FaChevronCircleLeft onClick={closeAllCars} className='circleLeft3'/></div>
                    <div className='col-3 car_details' style={{maxHeight:"87vh",overflowY:"auto"}}>
                      <div className='row'>
                        <div className='col-10 pt-2'>
                          <h5>Details</h5>
                        </div>
                        <div className='col-1 pt-1'>
                          <h5 className='pointer' onClick={carDetailsHandle}>X</h5>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-12'>
                          <label style={{float:"right"}}>Last Updated: <span style={{color:"red"}}>
                            {ConvertToTimeZone(selectedVehicleInfo[0].tele_data.datetimeSending, selectedVehicleInfo[0].location_id)} EST</span></label>
                        </div>
                      </div>
                      <hr />
                      <div className='row'>
                        <div className='col-12'>
                          <div className="fw-bold">Status : <lable style={{color:"#e319e3",fontSize:"20px"}}>
                          {(() => {
                              const statusValue = typeof selectedVehicleInfo[0].tele_data?.status === "object"
                                ? selectedVehicleInfo[0].tele_data.status?.value 
                                : selectedVehicleInfo[0].tele_data?.status;
                              
                              return statusValue || "N/A";
                            })()}
                            </lable></div>
                          <p className="fw-bold">Data From: {selectedVehicleInfo[0].data_from}</p>
                          <p className="fw-bold">{selectedVehicleInfo[0].make} {selectedVehicleInfo[0].model}</p>
                          <div><lable className="fw-bold">Vin : </lable>{selectedVehicleInfo[0].vin_number}</div>
                          <div><lable className="fw-bold">Plate : </lable>{selectedVehicleInfo[0].plate}</div>
                          <div><lable className="fw-bold">R/A : </lable>{(selectedVehicleInfo[0].agreement_number)?selectedVehicleInfo[0].agreement_number:""}</div>
                          <div style={{color:selectedVehicleInfo[0].agreement_type === 'In Agreement'?'green':'grey',float:"right"}}><lable className="fw-bold">{selectedVehicleInfo[0].agreement_type}</lable></div>
                        </div>
                      </div>
                      <hr />
                      <div className='row'>
                        <div className='col-12'>
                          <span className="fw-bold"><GiCarWheel style={{width:"25px",height:"25px"}}/>Tire Pressure</span>
                        </div>
                        {/* <div className='col-6'>Front(L): <b>{(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.front.left)?selectedVehicleInfo[0].tele_data.tirePressure.front.left.value:""}{(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.front.left)?selectedVehicleInfo[0].tele_data.tirePressure.front.left.unit:""}</b></div>
                        <div className='col-6'>Front(R): <b>{(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.front.right)?selectedVehicleInfo[0].tele_data.tirePressure.front.right.value:""}{(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.front.right)?selectedVehicleInfo[0].tele_data.tirePressure.front.right.unit:""}</b></div>
                        <div className='col-6'>Rear(L): <b>{(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.rear.left)?selectedVehicleInfo[0].tele_data.tirePressure.rear.left.value:""}{(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.rear.left)?selectedVehicleInfo[0].tele_data.tirePressure.rear.left.unit:""}</b></div>
                        <div className='col-6'>Rear(R): <b>{(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.rear.right)?selectedVehicleInfo[0].tele_data.tirePressure.rear.right.value:""}{(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.rear.right)?selectedVehicleInfo[0].tele_data.tirePressure.rear.right.unit:""}</b></div> */}
                        <div className="row">
                          {["Front(L)", "Front(R)", "Rear(L)", "Rear(R)"].map((label, index) => {
                            const position = label.includes("Front")
                              ? "front"
                              : "rear";
                            const side = label.includes("(L)")
                              ? "left"
                              : "right";

                            const tirePressure =
                              selectedVehicleInfo?.[0]?.tele_data?.tirePressure?.[position]?.[side];

                            return (
                              <div className="col-6" key={index} style={{fontSize:"15px"}}>
                                {label}:{" "}
                                <b>
                                  {tirePressure?.value ? tirePressure.value.toFixed(2) + tirePressure.unit  : "N/A"}
                                  {/* {tirePressure?.unit || ""} */}
                                </b>
                              </div>
                            );
                          })}
                        </div>
                        
                        <div className='col-12 justify-content-end d-flex' style={{fontSize:12}}>Last Updated: <b style={{color:"#eb6834"}}>
                          {/* {(selectedVehicleInfo[0].tele_data.tirePressure && selectedVehicleInfo[0].tele_data.tirePressure.front.left)?ConvertToTimeZone(selectedVehicleInfo[0].tele_data.datetime,selectedVehicleInfo[0].location_id):""}</b></div> */}
                          {
                            selectedVehicleInfo?.[0]?.tele_data?.tirePressure?.front?.left
                            ? ConvertToTimeZone(
                                selectedVehicleInfo[0].tele_data.datetime,
                                selectedVehicleInfo[0].location_id
                              )
                            : "N/A"
                          }</b></div>
                      </div>
                      <hr />
                      <div className='row'>
                        <div className='col-6'>
                          <span className="fw-bold"><PiEngineFill style={{width:"25px",height:"25px"}}/>Engine</span>
                        </div>
                        <div className='col-6'>
                          <span className="fw-bold" style={{color:"#e319e3"}}>{(selectedVehicleInfo[0].tele_data.engine.status)?selectedVehicleInfo[0].tele_data.engine.status.value:"N/A"}</span>
                        </div>
                        <div className='col-6'>
                          battery: 
                          <b>
                            {(selectedVehicleInfo[0].tele_data.engine.battery && selectedVehicleInfo[0].tele_data.engine.battery.voltage) 
                              ? selectedVehicleInfo[0].tele_data.engine.battery.voltage.value : ""}
                            {(selectedVehicleInfo[0].tele_data.engine.battery && selectedVehicleInfo[0].tele_data.engine.battery.voltage) 
                              ? selectedVehicleInfo[0].tele_data.engine.battery.voltage.unit : ""}
                          </b>
                        </div>
                        <div className='col-6'>
                          coolant: 
                          <b>
                            {(selectedVehicleInfo[0].tele_data.engine.coolant && selectedVehicleInfo[0].tele_data.engine.coolant.temperature) 
                              ? selectedVehicleInfo[0].tele_data.engine.coolant.temperature.value : ""}
                            {(selectedVehicleInfo[0].tele_data.engine.coolant && selectedVehicleInfo[0].tele_data.engine.coolant.temperature) 
                              ? selectedVehicleInfo[0].tele_data.engine.coolant.temperature.unit : ""}
                          </b>
                        </div>
                        <div className='col-12'>
                          speed: 
                          <b>
                            {(selectedVehicleInfo[0].tele_data.engine.speed) 
                              ? selectedVehicleInfo[0].tele_data.engine.speed.value : ""}
                            {(selectedVehicleInfo[0].tele_data.engine.speed) 
                              ? selectedVehicleInfo[0].tele_data.engine.speed.unit : ""}
                          </b>
                        </div> 
                        <div className='col-12 justify-content-end d-flex' style={{fontSize:12}}>Last Updated: <b style={{color:"#eb6834"}}>{(selectedVehicleInfo[0].tele_data.engine.status)?ConvertToTimeZone(selectedVehicleInfo[0].tele_data.datetime,selectedVehicleInfo[0].location_id) :""}</b></div>
                      </div>
                      <hr />
                      <div className='row'>
                        <div className='col-8'>
                          <p className="fw-bold"><GrMapLocation /> Location Details</p>
                        </div>
                        <div className='col-12'><span>Coordinates : <b>{selectedVehicleInfo[0].tele_data.geolocation.latitude}, {selectedVehicleInfo[0].tele_data.geolocation.longitude}</b></span></div>
                        <div className='col-12'><p style={{marginLeft:"15px"}}><FaLocationArrow /> {selectedAddress}</p></div>
                        <div className='col-12 justify-content-end d-flex' style={{fontSize:12}}>Last Updated: <b style={{color:"#eb6834"}}>{(selectedVehicleInfo[0].tele_data.geolocation)?ConvertToTimeZone(selectedVehicleInfo[0].tele_data.datetime, selectedVehicleInfo[0].location_id):""}</b></div>
                      </div>
                      <hr />
                      <div className='row'>
                        <div className='col-8'>
                          <p className="fw-bold">Additional Info</p>
                        </div>
                        <div className='col-12'><FaCarSide /> Vehicle Moving: <b>{(selectedVehicleInfo[0].tele_data.moving && selectedVehicleInfo[0].tele_data.moving.value)?"Yes":"No"}</b></div>
                        <div className='col-12'><IoIosSpeedometer /> Speed: <b>{(selectedVehicleInfo[0].tele_data.speed)?handleUnitType(selectedVehicleInfo[0].tele_data.speed.value,selectedVehicleInfo[0].unit_type):"0"} {selectedVehicleInfo[0].unit_type}/h</b></div>
                        <div className='col-12'><IoIosSpeedometer /> Odometer: <b>{(selectedVehicleInfo[0].tele_data.odometer)?handleUnitType(selectedVehicleInfo[0].tele_data.odometer.value,selectedVehicleInfo[0].unit_type):""} {selectedVehicleInfo[0].unit_type}</b></div>
                        {/* <div className='col-12'><BsFillFuelPumpFill /> Fuel Level: <b>{(selectedVehicleInfo[0].tele_data.fuel)?handleglType(selectedVehicleInfo[0].tele_data.fuel.level.value,selectedVehicleInfo[0].gl_type):"N/A"}</b></div> */}
                        <div className='col-12'><BsFillFuelPumpFill /> Fuel Level: <b>
                          {/* {selectedVehicleInfo?.[0]?.tele_data?.fuel?.level?.percentage ? selectedVehicleInfo[0].tele_data.fuel.level.percentage + " %" : "N/A"} */}
                          {selectedVehicleInfo[0].tele_data.fuel &&
                            (
                              (selectedVehicleInfo[0].tele_data.fuel.level && selectedVehicleInfo[0].tele_data.fuel.level.percentage) 
                                ? selectedVehicleInfo[0].tele_data.fuel.level.percentage + " %"
                                : selectedVehicleInfo[0].tele_data.fuel.percentage 
                                  ? selectedVehicleInfo[0].tele_data.fuel.percentage + " %"
                                  : "N/A"
                            )}
                          </b></div>
                        <div className='col-12'><BsFillFuelPumpFill /> Fuel Residual Autonomy: <b>{(selectedVehicleInfo[0].tele_data.fuel && selectedVehicleInfo[0].tele_data.fuel.residualAutonomy)?handleUnitType(selectedVehicleInfo[0].tele_data.fuel.residualAutonomy.value,selectedVehicleInfo[0].unit_type):"0"} {selectedVehicleInfo[0].unit_type}</b></div>
                        <div className='col-12'><MdAirlineSeatReclineExtra /> Driver Seatbelt Wearing: <b>{(selectedVehicleInfo[0].tele_data.seatbelt && selectedVehicleInfo[0].tele_data.seatbelt.driver && selectedVehicleInfo[0].tele_data.seatbelt.driver.value)?"Yes":"No"}</b></div>
                        <div className='col-12'><GiCarDoor /> Doors Locked: <b>{(selectedVehicleInfo[0].tele_data.doors && selectedVehicleInfo[0].tele_data.doors.locked && selectedVehicleInfo[0].tele_data.doors.locked.value)?"Yes":"No"}</b></div>
                        <div className='col-12 justify-content-end d-flex' style={{fontSize:12}}>Last Updated: <b style={{color:"#eb6834"}}>{(selectedVehicleInfo[0].tele_data.odometer)?ConvertToTimeZone(selectedVehicleInfo[0].tele_data.datetime,selectedVehicleInfo[0].location_id):""}</b></div>
                      </div>
                      <hr />
                      {selectedVehicleInfo[0].make != 'VOLKSWAGON'? 
                        <div className='row'>
                          <div className='col-8'>
                            <p className="fw-bold">Control Vehicle</p>
                          </div>
                          <div className='col-4'>
                            <p className="fw-bold">{lockStatus}</p>
                          </div>
                          <div className='col-12 l-3 d-flex justify-content-center'>
                            <label htmlFor="my-switch">Lock &nbsp;</label>
                            <ReactSwitch
                              checked={checked}
                              onChange={handleChange}
                            />
                            <label htmlFor="my-switch" className="ml-2">&nbsp; Un Lock</label>
                          </div>
                        </div>
                        :
                        <div className="container mt-4">
                          <h4 className="mb-4 fw-bold">Control Vehicle</h4>
                          <p className="text-muted mb-4">
                            Control the vehicle based on secure remote commands.
                          </p>
    
                          <div className="d-flex flex-column gap-3">
                            <div className="d-flex justify-content-between align-items-center p-3 border rounded shadow-sm">
                              <button
                                className="btn btn-outline-dark d-flex align-items-center gap-2"
                                disabled={loadingCommand !== null}
                                onClick={() => handleCommandClick('lock_unlock')}
                              >
                                {renderButtonContent(
                                  doorLocked ? <FaUnlock /> : <FaLock />,
                                  doorLocked ? 'Unlock' : 'Lock',
                                  'lock_unlock'
                                )}
                              </button>
                              
                              <div className="d-flex align-items-center gap-2">
                                <span className="fw-medium text-muted">
                                  {doorLocked ? 'Locked' : 'Unlocked'}
                                </span>
    
                                <div style={{ width: 24 }}></div>
                              </div>
                            </div>
    
                            <div className="d-flex justify-content-between align-items-center p-3 border rounded shadow-sm">
                              <button
                                className="btn btn-outline-dark d-flex align-items-center gap-2"
                                disabled={loadingCommand !== null}
                                onClick={() => handleCommandClick('car_finder')}
                              >
                                {renderButtonContent(<FaMapMarkerAlt />, 'Car Finder', 'car_finder')}
                              </button>
    
                              {/* <div className="d-flex align-items-center gap-2">
                                <span className="fw-medium text-muted">
                                  {carFinderResult === 'Success' ? 'Success' : 'Failed'}
                                </span>
    
                                {carFinderResult === 'Success' ? (
                                  <button
                                    onClick={handleCarFinderRefresh}
                                    className="refresh-btn"
                                    title="Refresh location"
                                    style={{ backgroundColor: 'transparent' }}
                                  >
                                    <MdOutlineRefresh size={22} className={isRefreshing ? 'rotate-animation' : ''}/>
                                  </button>
                                ) : (
                                  <div style={{ width: 24 }}></div>
                                )}
                              </div> */}
                              <div className="d-flex align-items-center gap-2">
                                <span className="fw-medium text-muted">
                                  {carFinderResults[selectedVin] === 'Success' ? (
                                      <span className="text-success">
                                        <i className="bi bi-check-circle"></i> Success
                                      </span>
                                    ) : carFinderResults[selectedVin] === 'Failed' ? (
                                      <span className="text-danger">
                                        <i className="bi bi-x-circle"></i> Failed
                                      </span>
                                    ) : (
                                      <span className="text-muted">Find</span>
                                    )}
                                </span>

                                {carFinderResults[selectedVin] === 'Success' ? (
                                  <button
                                    onClick={handleCarFinderRefresh}
                                    className="refresh-btn"
                                    title="Refresh location"
                                    style={{ backgroundColor: 'transparent' }}
                                  >
                                    <MdOutlineRefresh size={22} className={isRefreshing ? 'rotate-animation' : ''}/>
                                  </button>
                                ) : (
                                  <div style={{ width: 24 }}></div>
                                )}
                              </div>
                            </div>
    
                            <div className="d-flex justify-content-between align-items-center p-3 border rounded shadow-sm">
                              <button
                                className="btn btn-outline-dark d-flex align-items-center gap-2"
                                disabled={loadingCommand !== null}
                                onClick={() => handleCommandClick('horn')}
                              >
                                {renderButtonContent(<FaBullhorn />, 'Horn', 'horn')}
                              </button>
                              <div className="d-flex align-items-center gap-2">
                                <span className="fw-medium text-muted">
                                  {hornOn ? 'On' : 'Off'}
                                </span>
    
                                <div style={{ width: 24 }}></div>
                              </div>
                            </div>
    
                            <div className="d-flex justify-content-between align-items-center p-3 border rounded shadow-sm">
                              <button
                                className="btn btn-outline-dark d-flex align-items-center gap-2"
                                disabled={loadingCommand !== null}
                                onClick={() => handleCommandClick('lights')}
                              >
                                {renderButtonContent(<FaLightbulb />, 'Lights', 'lights')}
                              </button>
                              <div className="d-flex align-items-center gap-2">
                                <span className="fw-medium text-muted">
                                  {lightsOn ? 'On' : 'Off'}
                                </span>
                                <div style={{ width: 24 }}></div>
                              </div>
                            </div>
    
                          </div>
                        </div>
                      }
                      <hr />
                    </div></>
                    )
                  }
                  </> : <div className='margin' style={{borderRight:"1px solid #ccc"}}>
                    <FaChevronCircleRight  onClick={openAllCars} className='circleLeft2'/>
                    </div>
                  }
                  <div className={`${isDetailsOpen ? 'col-9':'col-12'}`}>
                    {fleetMonitorList.length > 0 && geofenceCoordinates.state?
                      <div className='row'>
                        <GoogleMapComponent 
                          key={JSON.stringify(dataToSend)} 
                          dataToSend={dataToSend} 
                          geofenceCoordinates={geofenceCoordinates} 
                          teleStatus={fleetMonitorList} 
                          selectedVehicle={selectedVehicleInfo}
                        />
                      </div>
                      :<h3 className='text-center mt-4' style={{color:"red"}}>No Data / Please select location</h3>}
                  </div>
                </div>
              </div>
              </>
          </Container>
      </div>
    )
}

export default Monitor;